import { getRegisterFunction } from '../../utils/register.js';
import { OneUxRadioElement } from './OneUxRadioElement.js';
export const register = getRegisterFunction(OneUxRadioElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-radio': OneUxRadioElement;
    "radio-b0931cdaece4f227dcb40c13b22a3381": OneUxRadioElement;
  }
}